import { createAction } from 'typesafe-actions';
import { IPumpingStationMotorSize } from '../../../../@types/model/masterData/pumpingStation/motorSize';

export default class MasterDataPumpingStationMotorSizeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_SIZES', resolve => (pumps : Array<IPumpingStationMotorSize>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_SIZES_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}